import { Alert } from "@mui/material";
import trans from "helpers/trans";
import { FC } from "react";
import { useSelector } from "react-redux";
import { PageContent } from "ui";

const AppError: FC = () => {
    const errorMessage = useSelector((state: any) => state.app.errorMessage);
    return (
        <PageContent
            sx={{
                flexGrow: 1,
                flexDirection: "column",
                display: "flex",
                margin: "0 auto",
                width: "fit-content",
                height: "100vh",
                justifyContent: "center",
            }}
        >
            <Alert severity="error">
                {errorMessage
                    ? errorMessage
                    : trans("ui.requestMessage.message")}
            </Alert>
        </PageContent>
    );
};

export default AppError;
